/* unplugin-vue-components disabled */import script from "./NowOwingTaxes.vue?vue&type=script&setup=true&lang=js"
export * from "./NowOwingTaxes.vue?vue&type=script&setup=true&lang=js"

import "./NowOwingTaxes.vue?vue&type=style&index=0&id=36ba5af7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ba5af7"]])

export default __exports__